export const units: any[] = [
  {
    name: 'Equities',
    icon: 'icon-graph-bar-line',
    id: 1,
    key: 'equities',
    image: '/assets/images/categories/equities.jpg',
    products: [
      {
        id: 300000001885189,
        status: undefined,
        key: 'equity',
        name: 'Equity',
        productCat: 'equity',
      },
    ],
  },

  {
    name: 'Margin Trading',
    icon: 'icon-treasuries-white',
    id: 2,
    key: 'margin-trading',
    image: '/assets/images/categories/margin-trading.jpg',
    products: [
      {
        id: 300000001885199,
        status: undefined,
        key: 'margin-trading',
        name: 'Margin Trading',
        productCat: 'margin-trading',
      },
    ],
  },
  {
    name: 'Fixed Income',
    icon: 'icon-graph-pie-1',
    id: 3,
    key: 'fixed-income',
    url: 'fixed-income',
    division: 'CALI',
    image: '',
    products: [
      {
        id: 300000001885207,
        status: undefined,
        key: 'fixed-income',
        name: 'Fixed Income',
        productCat: 'ut',
      },
    ],
  },
];

export const products = units
  .reduce((acc, cur) => {
    return [...acc, ...cur.products];
  }, [])
  .sort((a, b) => {
    let nameA = a.name.toUpperCase();
    let nameB = b.name.toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  });

export function ResetUnits() {
  products.forEach((product) => {
    product.status = undefined;
    product.statusPending = undefined;
  });
}

export function GetPortalProductKeyFromId(id) {
  let productKey;

  units.forEach((unit) => {
    if (productKey) {
      return;
    }
    const product = unit.products.find((p) => p.id === id);
    if (product) {
      productKey = product.key;
    }
  });
  return productKey;
}

export function GetPortalProductFromId(id) {
  let productRtn;
  units.forEach((unit) => {
    if (productRtn) {
      return;
    }
    const product = unit.products.find((p) => p.id === id);
    if (product) {
      productRtn = product;
    }
  });
  return productRtn;
}

export function GetPortalProductIdFromKey(productKey: string) {
  let productId;
  units.forEach((unit) => {
    if (productId) {
      return;
    }
    const product = unit.products.find((p) => p.key === productKey);
    if (product) {
      productId = product.id;
    }
  });
  return productId;
}
export function GetPortalKeyFromProductId(id: number) {
  let productKey;
  units.forEach((unit) => {
    if (productKey) {
      return;
    }
    const product = unit.products.find((p) => p.id === Number(id));
    if (product) {
      productKey = product.key;
    }
  });
  return productKey;
}
export function GetPortalProductFromKey(productKey: string) {
  let product;
  units.forEach((unit) => {
    if (product) {
      return;
    }

    if (productKey === 'unit-trust-one-signup') {
      let filterdePrd = unit.products.find((p) => p.key === productKey);
      if (filterdePrd) {
        product = filterdePrd;
      }
    } else {
      product = unit.products.find((p) => p.key === productKey);
    }
  });
  return product;
}
export function GetPortalProductNameFromId(id) {
  let productName;
  units.forEach((unit) => {
    if (productName) {
      return;
    }
    const product = unit.products.find((p) => p.id === id);
    if (product) {
      productName = product.name;
    }
  });
  return productName;
}

export function GetPortalProductIdFromName(productName: string) {
  let productId;
  units.forEach((unit) => {
    if (productId) {
      return;
    }
    const product = unit.products.find((p) => p.name.toLowerCase() === productName.toLowerCase());
    if (product) {
      productId = product.id;
    }
  });
  return productId;
}
/// **********category **** /

export function GetPortalCategoryKeyFromId(id: number) {
  let categoryKey;
  if (categoryKey) {
    return;
  }
  const category = units.find((cat) => cat.id === id);
  if (category) {
    categoryKey = category.key;
  }
  return categoryKey;
}

export function GetPortalCategoryIdFromKey(categoryKey: string) {
  let categoryId;

  if (categoryId) {
    return;
  }
  const category = units.find((cat) => cat.key === categoryKey);
  if (category) {
    categoryId = category.id;
  }
  return categoryId;
}

export function GetPortalCategoryNameFromId(id: number) {
  let categoryName;
  const category = units.find((cat) => cat.id === Number(id));
  if (category) {
    categoryName = category.name;
  }

  return categoryName;
}
export function GetPortalCategoryImageFromId(id: number) {
  let categoryImage;
  const category = units.find((cat) => cat.id === Number(id));
  if (category) {
    categoryImage = category.image;
  }
  return categoryImage;
}

export function GetProductsFromCategory(id: number) {
  const category = units.find((cat) => cat.id === Number(id));
  return (category && category.products) || null;
}

export function GetCategoryFromProductId(id) {
  return units.find((cat) => {
    return cat.products.some((product) => product.id === id);
  });
}

export let proofFieldsToValidate = {
  lastName: [{ name: 'Last Name', format: '', fields: '' }],
  initials: [{ name: 'Initials', format: '', fields: '' }],
  namesDenotedByInitials: [{ name: 'Names Denoted by Initials', format: '', fields: '' }],
  dateOfBirth: [{ name: 'Date of Birth', format: 'date', fields: '' }],
  nationality: [{ name: 'Nationality', format: '', fields: '' }],
  passportDateOfIssue: [{ name: 'Passport Date of Issue', format: 'date', fields: '' }],
  nicDateOfIssue: [{ name: 'NIC Date of Issue', format: 'date', fields: '' }],
  factaNo: [{ name: 'factaNo', format: '', fields: '' }],
  permanentAddress: [
    {
      name: 'Permanent Address',
      format: 'addr',
      fields: ['addressLine1', 'addressLine2', 'city', 'postalCode', 'country', 'district', 'postalCode'],
    },
  ],
};

// export function GetPortalProductListFromcategoryId()
